<template>
  <el-transfer
      v-model="value"
      :props="props"
      :titles="['未分配人员', '已分配人员']"
      :data="data"
      style="text-align: left; display: inline-block"
      filterable
  />
</template>
<script>
import {getAllStaff} from "@/request/BasicDataApi";

export default {
  name: "index",
  props:['title','orivalue'],
  data() {
    return {
      props: {
        key: 'key',
        label: 'label',
        value:'value'
      },
      value: [],
      data: [],
    }
  },
  created() {
    getAllStaff().then(res => {
      let data = res.data
      let transData = data.map(item => {
        return {
          label: item.departName + '/' + item.name,
          value: item.id,
          key: item.id,
        }
      })
      this.data = transData
    })
  },
  methods: {},
  watch:{
    'value'(e){
      console.log('value',this.value)
      this.$emit('data',e)
    },
    'orivalue': {
      handler(newName, oldName){
        this.value = newName
        console.log('orivalue',this.value)
      },
      immediate:true,
    }
  }
}
</script>

<style scoped>

</style>
